<div *ngIf="showModal" class="modal" [ngClass]="modalType">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ modalTitle }}</h4>
      <button type="button" class="close" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <p>{{ modalMessage }}</p>
    </div>
  </div>
</div>
